// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__2Eh_a","cell":"ColumnAccessor_cell__2kRjF","firstCellAccent":"ColumnAccessor_firstCellAccent__39Cu7"};